import React from 'react';
import { observer } from 'mobx-react';
var DocumentsValue = function DocumentsValue(_ref) {
  var vm = _ref.vm;
  return /*#__PURE__*/React.createElement("div", {
    className: "prompt-line__text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "answer-documents"
  }, vm.options.filter(function (option) {
    return (vm.answer || []).some(function (a) {
      return a.id === option.id;
    });
  }).map(function (option) {
    return option.text;
  }).join(', ')));
};
export default observer(DocumentsValue);
//# sourceMappingURL=index.js.map
